import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { RegistryToken } from './registry-token';
export { RegistryToken };
import { registryTokenSchema } from '@schemas/business-objects/registry-token';
import { LoginSessionFormGroup } from './login-session-form-group';
import { NpmPackageFormGroup } from './npm-package-form-group';
import { UserFormGroup } from './user-form-group';

export class RegistryTokenFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    name: SchemaFormControl;
    tokenHash: SchemaFormControl;
    tokenPrefix: SchemaFormControl;
    canPublish: SchemaFormControl;
    expiresAt: SchemaFormControl;
    lastUsedAt: SchemaFormControl;
    revokedAt: SchemaFormControl;
    publishedFromRepository: SchemaFormControl;
    publishedFromWorkflow: SchemaFormControl;
    publishedFromRunId: SchemaFormControl;
    actor: SchemaFormControl;
    userId: SchemaFormControl;
    user: UserFormGroup;
    loginSession: LoginSessionFormGroup;
    npmPackageId: SchemaFormControl;
    npmPackage: NpmPackageFormGroup;
  };

  declare value: Partial<RegistryToken>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(registryTokenSchema, RegistryToken, data, options);
  }

  get object(): RegistryToken {
    return new RegistryToken(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'user':
        return new UserFormGroup();
      case 'loginSession':
        return new LoginSessionFormGroup();
      case 'npmPackage':
        return new NpmPackageFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<RegistryToken[]> {
    return RegistryToken.find(filter);
  }

  static async findOne(filter?: any): Promise<RegistryToken | null> {
    return RegistryToken.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<RegistryToken> {
    return RegistryToken.findById(id, filter);
  }

  static async create(data: Partial<RegistryToken>): Promise<RegistryToken> {
    return RegistryToken.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<RegistryToken>,
  ): Promise<RegistryToken> {
    return RegistryToken.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return RegistryToken.deleteById(id);
  }
}

export class RegistryTokenFormArray extends PersistedFormArray {
  declare controls: RegistryTokenFormGroup[];

  readonly entityName = 'RegistryToken' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(registryTokenSchema, RegistryToken, options);
  }

  protected override createItemGroup() {
    return new RegistryTokenFormGroup();
  }

  get array(): RegistryToken[] {
    return this.controls.map((group: RegistryTokenFormGroup) => group.object);
  }
}

export class RegistryTokenPersistedArray extends PersistedArray<RegistryToken> {
  readonly entityName = 'RegistryToken' as const;

  constructor(options?: PersistedArrayOptions) {
    super(RegistryToken, options);
  }
}
